
import { Component, PropSync, Vue, Watch } from 'vue-property-decorator';
import SvgCheck from '@/assets/icons/check.svg';
import SaveBtnTooltip from "@/components/base/buttons/SaveBtnTooltip.vue";
import { ICreatePersonalRate, IPersonalRates } from "@/api/types/offers";
import { applyEditedPersonalRate, getPersonalRateAmounts } from "@/utils/personalRate/personalRateUpdate";
import { Mutation } from "vuex-class";
import EditModeTextField from "@/components/base/form/EditModeTextField.vue";
import DateTimePickerNew from "@/components/base/pickers/DateTimePickerNew.vue";
import BaseDateTimePicker from "@/components-UI/BaseDateTimePicker.vue";

@Component({
    components: {
        DateTimePickerNew,
        BaseDateTimePicker,
        EditModeTextField,
        SaveBtnTooltip,
        SvgCheck,
    },
})

export default class BulkEditing extends Vue {
    @PropSync('editedItems', { type: Array }) editedItemsSync!: ICreatePersonalRate[];
    @PropSync('items', { type: Array }) itemsSync!: IPersonalRates[];

    @Mutation('SET_UNSAVED_DATA_STATE') setUnsavedDataState;

    menu = false;
    editedRate: {revenue: number | null, payout: number | null, percent: number | null, isDefaultRevenue: boolean, start_date: string} = {
        revenue: null,
        payout: null,
        percent: null,
        start_date: '',
        isDefaultRevenue: false,
    };

    isSubmit = false;

    get isDisabledPercent(): boolean {
        return !!this.editedRate.payout;
    }

    get isDisabledPayout(): boolean {
        return !!this.editedRate.percent;
    }

    get availableDates(): { start: Date, end: Date | null } {
        return { start: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), end: null };
    }

    countPayout(): void {
        if (this.editedRate.percent && this.editedRate.percent > 100) {
            this.$set(this.editedRate, 'percent', 100);
        } else if (this.editedRate.percent && this.editedRate.percent < 0) {
            this.$set(this.editedRate, 'percent', null);
        }
    }

    openMenu(): void {
        this.menu = true;
        this.isSubmit = false;
        this.editedRate = {
            revenue: null,
            payout: null,
            percent: null,
            start_date: '',
            isDefaultRevenue: false,
        };
    }
    @Watch('menu')
    toggleScrollButtonVisibility(): void {
        const buttonDiv = document.querySelector('.extended-report-table__scroll-btns');
        (buttonDiv as HTMLElement).style.display  = this.menu ? 'none' : 'flex';
    }

    editRate(): void {
        this.editAllRates();
        this.isSubmit = true;
        this.menu = false;
    }

    calcPayout(value: any, newValue: any): number {
        return newValue.percent ?
            (value.personal_rates.revenue.amount * newValue.percent) / 100 :
            newValue.revenue && !newValue.payout && value.personal_rate_payout_percent ?
                (+newValue.revenue * +value.personal_rate_payout_percent) / 100 :
                +newValue.payout! || value.personal_rates.payout.amount;
    }

    editAllRates(): void {
        const rate = this.editedRate;
        let editedItems: ICreatePersonalRate[] = [];
        this.itemsSync.forEach( i => {
            // если выплата в процентах, тогда не применяем массовое редактирование
            if (i.personal_rates.payout.type !== 'fixed') return;

            const saved = getPersonalRateAmounts(i);
            i.personal_rates.revenue.amount = rate.isDefaultRevenue ? i.goal.revenue.amount : +rate.revenue! || i.personal_rates.revenue.amount;
            i.personal_rates.payout.amount = this.calcPayout(i, rate);
            i.personal_rates.start_date = rate.start_date;
            if (i.personal_rates.payout.amount > i.personal_rates.revenue.amount) {
                i.personal_rate_payout_percent = 100;
                i.personal_rates.payout.amount = i.personal_rates.revenue.amount;
            } else {
                i.personal_rate_payout_percent = rate.payout! ? (i.personal_rates.payout.amount / i.personal_rates.revenue.amount * 100).toFixed(1) :
                    rate.percent || i.personal_rate_payout_percent;
            }
            editedItems = applyEditedPersonalRate(editedItems, {
                affiliate_id: i.affiliate.legacy_id,
                goal_id: i.goal.legacy_id,
                offer_id: i.offer.legacy_id,
                id: i.personal_rates.id,
                revenue: i.personal_rates.revenue.amount,
                payout: parseFloat((i.personal_rates.payout.amount).toFixed(2)),
                start_date: i.personal_rates.start_date,
            }, saved);
        });
        this.$emit('update:editedItems', editedItems);
        this.setUnsavedDataState(editedItems.length > 0);
    }

    changeCheckbox(): void {
        this.editedRate.revenue =  null;
    }
}
